var render = function render(){var _vm=this,_c=_vm._self._c;return _c('row',[_c('col3',[_c('gravatar',{attrs:{"selected_properties":_vm.user.avatar_properties}})],1),_c('col9',[_vm._v(" "+_vm._s(_vm.user.first_name)+" "+_vm._s(_vm.user.last_name)+" "),_c('br'),_vm._v(" "+_vm._s(_vm.mutation.mutated_at)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }